/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown> }} Exclusive_To_TierInputs */

const en_exclusive_to_tier = /** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This listing is exclusive to Tier ${i?.tier}+ members. Join below to unlock.`)
};

const id_exclusive_to_tier = /** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listing ini eksklusif untuk anggota Paket ${i?.tier}+. Bergabunglah di bawah ini untuk membuka akses.`)
};

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const es_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const fr_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const de_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const ja_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const zh_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const ar_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const it_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const ru_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const pt_exclusive_to_tier = en_exclusive_to_tier;

/** @type {(inputs: Exclusive_To_TierInputs) => LocalizedString} */
const ko_exclusive_to_tier = en_exclusive_to_tier;

/**
* | output |
* | --- |
* | "This listing is exclusive to Tier {tier}+ members. Join below to unlock." |
*
* @param {Exclusive_To_TierInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_to_tier = /** @type {((inputs: Exclusive_To_TierInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_To_TierInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_to_tier(inputs)
	if (locale === "es") return es_exclusive_to_tier(inputs)
	if (locale === "fr") return fr_exclusive_to_tier(inputs)
	if (locale === "de") return de_exclusive_to_tier(inputs)
	if (locale === "ja") return ja_exclusive_to_tier(inputs)
	if (locale === "zh") return zh_exclusive_to_tier(inputs)
	if (locale === "ar") return ar_exclusive_to_tier(inputs)
	if (locale === "id") return id_exclusive_to_tier(inputs)
	if (locale === "it") return it_exclusive_to_tier(inputs)
	if (locale === "ru") return ru_exclusive_to_tier(inputs)
	if (locale === "pt") return pt_exclusive_to_tier(inputs)
	return ko_exclusive_to_tier(inputs)
});